import styled from "styled-components";

export const AboutStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 50px;
  font-size: 20px;
  margin-bottom: 50px;
  gap: 20px;

  @media only screen and (max-width: 560px) {
    padding: 20px;
  }
`;

export const AboutContent = styled.div`
  margin-top: 20px;
  line-height: 2rem;
  font-size: 25px;
  letter-spacing: 0.5px;

  @media only screen and (max-width: 560px) {
    padding: 20px;
    font-size: 18px;
  }
`;
